import { select, put } from 'redux-saga/effects';
import { getUserSelectedAccountCode } from '../../../../app/appSelectors';
import { SOCKET_TYPE_MESSAGES, oppositeSubscriptionName } from '../../../../mobileAppCore/mobileAppConstants';
import { IMobileAppRootState } from '../../../../mobileAppCore/types/mobileAppState.t';
import {
    getLiteTradeConfig,
    getLiteTradeSessionToken,
    getMarketDataWatchers,
} from '../../../../modules/LiteTrade/liteTradeSelectors';
import { websocketOpenSubscriptionById } from '../../websocketReducer';
import _ from 'lodash';
import { updateMarketDataAction } from '../../../../modules/LiteTrade/liteTradeActions';
import { getWebsocketSubscriptionById } from '../../websocketSelectors';
import { IWebsocketSubscriptionById } from '../../types/websocketSubscribersReducer.t';


function* subscriptionMarketDataQuoteSaga() {
    const liteTradeConfig = yield select(getLiteTradeConfig);
    const channel = liteTradeConfig?.wssMdUrl;
    const type = SOCKET_TYPE_MESSAGES.MARKET_DATA_OPEN;
    const sessionToken = yield select(getLiteTradeSessionToken);
    const selectedAccountCode = yield select(getUserSelectedAccountCode);
    const marketDataWatchers = yield select(getMarketDataWatchers);
    const symbols = _.uniq(marketDataWatchers?.map((item) => item.symbol)).sort();

    const requestId = `quote-${SOCKET_TYPE_MESSAGES.MARKET_DATA_OPEN}`;
    const prev: IWebsocketSubscriptionById = yield select(getWebsocketSubscriptionById(channel, requestId));

    const prevSymbols = prev?.prev?.symbols;
    if (prevSymbols && _.isEqual(prevSymbols, symbols) && (prev?.state === 'open' || prev?.state === 'opening' )) {
        return;
    }

    if (sessionToken && selectedAccountCode)
        yield put(
            websocketOpenSubscriptionById({
                id: requestId,
                channel,
                prev: {
                    symbols,
                    selectedAccountCode,
                    sessionToken,
                },

                open: function (state: IMobileAppRootState) {
                    const sessionToken = getLiteTradeSessionToken(state);
                    const selectedAccountCode = getUserSelectedAccountCode(state);
                    const marketDataWatchers = getMarketDataWatchers(state);
                    const symbols = _.uniq(marketDataWatchers?.map((item) => item.symbol));

                    if (symbols.length === 0) {
                        return null;
                    }

                    return {
                        requestId,
                        type,
                        payload: {
                            account: `default:${selectedAccountCode}`,
                            symbols,
                            eventTypes: [
                                {
                                    type: 'Quote',
                                    format: 'COMPACT',
                                },
                            ],
                        },
                        session: sessionToken,
                        dataType: 'MarketData',
                    };
                },
                close: function (state: IMobileAppRootState) {
                    const sessionToken = getLiteTradeSessionToken(state);
                    return {
                        type: oppositeSubscriptionName[type],
                        refRequestId: requestId,
                        session: sessionToken,
                    };
                },
                process: function* (messageData: ReturnType<typeof JSON.parse>) {
                    if (messageData.type === 'Reject') {
                        console.log('%c subscriptionMarketDataQuoteSaga', 'color: red', messageData);
                    }
                    yield put(updateMarketDataAction(messageData.payload.events || []));
                },
            }),
        );
}

export default subscriptionMarketDataQuoteSaga;
